module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.definition) ? _c('div', [(_vm.downloadReportsModel) ? _c('uiv-modal', {
    attrs: {
      "append-to-body": "",
      "footer": false,
      "title": "Download Report",
      "backdrop": false,
      "size": "sm"
    },
    model: {
      value: (_vm.showDownloadReportsDialog),
      callback: function($$v) {
        _vm.showDownloadReportsDialog = $$v
      },
      expression: "showDownloadReportsDialog"
    }
  }, [_c('download-reports-dialog', {
    attrs: {
      "value": _vm.downloadReportsModel,
      "reportServices": _vm.reportServices,
      "modelServices": _vm.modelServices
    },
    on: {
      "dialogClosed": _vm.onDownloadReportsDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('uiv-modal', {
    attrs: {
      "size": "sm",
      "title": "Publish Options",
      "footer": false
    },
    model: {
      value: (_vm.showPublishOptionsDialog),
      callback: function($$v) {
        _vm.showPublishOptionsDialog = $$v
      },
      expression: "showPublishOptionsDialog"
    }
  }, [_c('publish-to-dashboard-options', {
    on: {
      "dialogAccepted": _vm.onPublishAccepted,
      "dialogCanceled": _vm.onPublishCanceled
    }
  })], 1)], 1), _vm._v(" "), (_vm.customFieldsEditorOptions) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "size": "lg",
      "title": _vm.customFieldsEditorOptions.title,
      "footer": false
    },
    model: {
      value: (_vm.showCustomFieldsEditor),
      callback: function($$v) {
        _vm.showCustomFieldsEditor = $$v
      },
      expression: "showCustomFieldsEditor"
    }
  }, [_c('strings-editor', {
    attrs: {
      "value": _vm.customFieldsEditorOptions
    },
    on: {
      "dialogClosed": _vm.onEditCustomFieldsDialogClosed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isValidNode),
      expression: "isValidNode"
    }]
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "setNameEdit"
    }
  }, [_vm._v("Set Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.setName),
      expression: "definition.setName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.isBusy,
      "value": "",
      "id": "setNameEdit",
      "placeholder": "Identifier for exported records",
      "required": ""
    },
    domProps: {
      "value": (_vm.definition.setName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.definition, "setName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy || !_vm.definitionIsDirty
    },
    on: {
      "click": _vm.onSaveDefinitionClick
    }
  }, [_vm._v("\n                                    Save Definition\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onValidateClick
    }
  }, [_vm._v("Validate")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.addExportClick
    }
  }, [_vm._v("Add Export")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onPublishAllClick
    }
  }, [_vm._v("Publish All")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onDownloadAllClick
    }
  }, [_vm._v("Download All")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onEditCustomFieldDefsClick
    }
  }, [_vm._v("Custom Fields (" + _vm._s(_vm.definition.customFieldDefs.length) + ") ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table export-table table-condensed",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.definition.exports), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "form-control input-sm",
      attrs: {
        "id": "queryEdit_" + index,
        "autocomplete": "new-password",
        "disabled": _vm.isBusy,
        "preselect": "",
        "type": "text",
        "required": "",
        "placeholder": "Select report"
      }
    }), _vm._v(" "), _c('uiv-typeahead', {
      attrs: {
        "target": "#queryEdit_" + index,
        "async-function": _vm.reportSearchFunction
      },
      model: {
        value: (item.query),
        callback: function($$v) {
          _vm.$set(item, "query", $$v)
        },
        expression: "item.query"
      }
    })], 1), _vm._v(" "), _c('td', _vm._l((item.nodePathAndNames), function(node, nodeIndex) {
      return _c('div', [_c('div', {
        staticClass: "input-group"
      }, [_c('input', {
        staticClass: "form-control",
        attrs: {
          "type": "search",
          "id": "nodeEdit_" + index + "_" + nodeIndex,
          "autocomplete": "new-password",
          "disabled": _vm.isBusy,
          "equired": "",
          "placeholder": "Select node"
        }
      }), _vm._v(" "), _c('uiv-typeahead', {
        attrs: {
          "target": "#nodeEdit_" + index + "_" + nodeIndex,
          "async-function": _vm.nodeSearchFunction
        },
        model: {
          value: (item.nodePathAndNames[nodeIndex]),
          callback: function($$v) {
            _vm.$set(item.nodePathAndNames, nodeIndex, $$v)
          },
          expression: "item.nodePathAndNames[nodeIndex]"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-btn"
      }, [_c('button', {
        staticClass: "btn btn-default",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.onRemoveNodeClick(item, item.nodePathAndNames[nodeIndex])
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-remove-sign",
        attrs: {
          "aria-hidden": "true"
        }
      })])])], 1)])
    }), 0), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.onAddNodeClick(item)
        }
      }
    }, [_vm._v("Add Node")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.onEditItemCustomFieldDefsClick(item)
        }
      }
    }, [_vm._v("Custom Fields (" + _vm._s(item.customFieldDefs.length) + ") ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.onPublishSingleClick(item)
        }
      }
    }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.downloadExportClick(item)
        }
      }
    }, [_vm._v("Download")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.onDuplicateItemClick(item)
        }
      }
    }, [_vm._v("Duplicate")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.deleteExportClick(item)
        }
      }
    }, [_vm._v("Delete")])])])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isValidNode),
      expression: "isValidNode"
    }],
    staticClass: "modal-footer"
  })])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "span": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Report")]), _vm._v(" "), _c('th', [_vm._v("Nodes")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d0295be4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0295be4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/publish-to-dashboard-dialog/publish-to-dashboard-dialog.vue.html
// module id = 1131
// module chunks = 0